import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  container: { padding: theme.spacing(2) },
  title: {
    fontWeight: 500,
    padding: theme.spacing(2),
    color: theme.palette.text.primary,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: theme.accent.main,
    paddingBottom: theme.spacing(2)
  },
  actionButtons: {
    padding: theme.spacing(2),
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: `calc(${theme.spacing(2)} + env(safe-area-inset-bottom, 0px))`,
    },
    // DESIGN.md §9: tablets render sm+ layouts with a coarse pointer. Declared
    // before the xs block so the phone 48px target keeps precedence.
    '@media (hover: none) and (pointer: coarse)': {
      '& button': { minHeight: 44 }
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      alignItems: 'stretch',
      '& > *': { width: '100%' },
      '& > :not(:first-child)': { marginLeft: 0, marginBottom: theme.spacing(1) },
      '& button': { minHeight: 48 }
    }
  },
  paper: {
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
      width: `calc(100% - ${theme.spacing(2)})`,
      maxHeight: `calc(100% - ${theme.spacing(2)})`
    }
  },
  fullScreenPaper: {
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    flex: 1
  },
  message: { overflowWrap: 'anywhere', whiteSpace: 'pre-line' }
}));
